module.exports = __webpack_public_path__ + "img/icon_tweed_14_active.aade9146.png";